import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'
import { FormattedMessage } from 'react-intl'
import { useParams, useNavigate } from 'react-router-dom'

import NavigationBar from '../partials/NavigationBar'
import Footer from '../partials/Footer'
import withAppStore from '../../util/withAppStore'
import styles from '../../../css/home.module.css'
import PreferenceTemperatureScale from '../partials/UserComponents/PreferenceTemperatureScale'
import PreferenceLanguage from '../partials/UserComponents/PreferenceLanguage'
import PreferencePinCode from '../partials/UserComponents/PreferencePinCode'
import PreferenceUnitsVolume from '../partials/UserComponents/PreferenceUnitsVolume'
import PreferenceUnitsFlow from '../partials/UserComponents/PreferenceUnitsFlow'

function UserPreferences (props) {
  const { preference } = useParams()
  const navigate = useNavigate()

  const backToUser = React.useCallback(() => {
    navigate('/user')
  }, [navigate])

  let preferenceSelector
  switch (preference) {
    case 'temperature':
      preferenceSelector = (
        <PreferenceTemperatureScale
          user={props.data.user}
          backToUser={backToUser}
        />
      )
      break
    case 'language':
      preferenceSelector = (
        <PreferenceLanguage
          user={props.data.user}
          backToUser={backToUser}
        />
      )
      break
    case 'unitsOfVolume':
      preferenceSelector = (
        <PreferenceUnitsVolume
          user={props.data.user}
          backToUser={backToUser}
        />
      )
      break
    case 'unitsOfFlow':
      preferenceSelector = (
        <PreferenceUnitsFlow
          user={props.data.user}
          backToUser={backToUser}
        />
      )
      break
    case 'pin':
      preferenceSelector = (
        <PreferencePinCode
          user={props.data.user}
          pinCode={props.data.pinCode}
          backToUser={backToUser}
        />
      )
      break
    default:
      backToUser()
  }

  return (
    <div>
      <Helmet><title>{props.pages.UserPreferences}</title></Helmet>
      <NavigationBar
        page={props.route.path}
        backFunc={backToUser}
        logOut={() => props.auth.logout(navigate)}
      />
      <div className={styles.pageWidth}>
        <div>
          <div className={styles.pageContainer}>
            <FormattedMessage
              id='profile.preferences'
              defaultMessage='Preferences'
              description='Preferences heading'
              tagName='h2'
            />
            <section>
              {preferenceSelector}
            </section>
            <br />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

UserPreferences.propTypes = {
  pages: PropTypes.object,
  data: PropTypes.object,
  route: PropTypes.object,
  auth: PropTypes.object,
}

export default withAppStore(UserPreferences)
